import React from "react";
import moment from "moment";
import {
  Table, Button, Modal, Spin, message, Input, Radio, TreeSelect, Select,
  Divider, Icon, Row, Col, Checkbox, DatePicker, Dropdown, Menu, Form
} from 'antd';

import LayoutWrapper from '../../layouts/LayoutWrapper.js';
import rosterService from '../../services/EmployeeManagement/roster-service.js';
import DepartmentStructure from '../../services/DepartmentStructure/department-structure-service.js';

@LayoutWrapper
@Form.create()
export default class EmployeeComponent extends React.Component {

  pageExist = true;

  state = {
    data: [],
    config: {},
    meta: {},
    pageStatus: "unload",
    configPageStatus: "unload",
    filters: {
      page: 1,
      job_number: "",
      real_name: "",
      department_id: "",
      job_status: '',
      multi_job_status:null,
      leave_date: null,
      leave_reason: '',
      export_ids:['1']
    },
    currentIndex: false,
    selectedIDs: [],
    importModalStatus: false,
    uploadedFile: null,
    exportPageStatus: "unload",
    exportModalStatus: false,
    exportColumn: {},
    selectedExportColumn: {},
    department: [],
    configModalStatus: false,
    jobStatusType: 0,
    triggeredPositions: []
  }

  rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {

      let ids = selectedRows.map(row => row.id);
      this.setState({ selectedIDs: ids });
    }
  }

  componentWillMount() {

    // if (sessionStorage.getItem("page")) {
    //   this.state.filters.page = parseInt(sessionStorage.getItem("page"));
    // }
    if (sessionStorage.getItem("employeeListFilter")) {
      this.setState({ filters: JSON.parse(sessionStorage.getItem("employeeListFilter")) }, () => {
      })
    }
    this.initializePage();
    this.initializeDepartment();
    sessionStorage.removeItem("employeeListFilter")

  }
  componentWillUnmount() {
    this.pageExist = false;
  }

  initializePage = () => this.setState({
    pageStatus: "reload"
  }, () => {
    const filters = {};
    for (let key in this.state.filters) {
      if (this.state.filters[key]) {
        filters[key] = this.state.filters[key];
      }
    }
    rosterService.fetchEmployeesListAll(filters, result => {
      // console.log(result);
      if (this.pageExist) {
        this.setState({
          pageStatus: "loaded",
          data: result.data
        })
      }
    })
  })
  initializeDepartment = () => {
    DepartmentStructure.getDepartmentsList({}, result => {
      // console.log(result);
      if (this.pageExist) {
        this.setState({ department: result.data })
      }
    })
  }

  deleteEmployee = () => {
    if (0 === this.state.selectedIDs.length) {
      message.error("请选择要删除的数据");
      return;
    }
    Modal.confirm({
      title: '确定删除这些数据么?',
      okText: '确认',
      cancelText: '取消',
      onOk: () => {
        rosterService.deleteEmployees({ ids: this.state.selectedIDs }, result => {
          // console.log(result);
          if (result.data.Success) {
            this.setState({
              selectedIDs: []
            }, () => {
              message.success("删除用户成功", 4);
              this.initializePage();
            })
          } else {
            message.error("删除用户失败: " + result.data.Message, 4);
          }
        }, error => message.error("删除数据失败", 4))
      },
      onCancel: () => { }
    });
  }
  toggleImportModal = () => this.setState({
    importModalStatus: !this.state.importModalStatus
  })
  downloadTemplate = () => {
    const ref = Modal.info({ content: "正在准备需要下载的模板" });
    rosterService.downloadTemplate(result => {
      ref.destroy();
      if (result.data.Success) {
        window.open(result.data.Message);
      }
    })
  }
  setUploadedFile = event => {
    this.setState({ uploadedFile: event.target.files[0] });
  }
  importEmployee = () => {
    console.log(this.state.uploadedFile)
    if (!this.state.uploadedFile) {
      message.error("请选择需要导入的文件", 4);
      return;
    }
    const ref = Modal.info({ content: "正在导入文件, 请稍后..." });
    const formData = new FormData();
    formData.append("uploadedFile", this.state.uploadedFile);
    rosterService.importRoster(formData, result => {
      ref.destroy();
      if (result.data.Success) {
        message.success('导入文件成功，' + result.data.Message, 4);
        this.setState({
          uploadedFile: null,
          importModalStatus: false
        }, this.initializePage)
        if (result.data.Object) {
          window.open(result.data.Object);
        }
      } else {
        message.error("导入文件失败, " + result.data.Errors[0], 4)
      }
    }, error => message.error("导入文件失败", 4));
  }

  exportEmployee = () => this.setState({
    exportPageStatus: "unload",
    exportModalStatus: true
  }, () => rosterService.fetchExportColumn({}, result => {
    // console.log(result);
    this.setState({
      exportPageStatus: "loaded",
      exportColumn: result.data.columns
    })
  }, error => this.setState({
    exportPageStatus: "error"
  })))
  toggleExportModal = () => this.setState({
    exportModalStatus: !this.state.exportModalStatus
  })
  setExportColumn = event => {
    if (event.target.checked) {
      this.setState({
        selectedExportColumn: {
          ...this.state.selectedExportColumn,
          [event.target.value]: this.state.exportColumn[event.target.value]
        }
      })
    } else {
      let copySelectedExportColumn = this.state.selectedExportColumn;
      delete copySelectedExportColumn[event.target.value];
      this.setState({
        selectedExportColumn: copySelectedExportColumn
      })
    }
  }
  exportEmployeeAction = () => {
    const ref = Modal.info({ content: "正在导出文件, 请稍后..." });
    const filters = {selectedExportColumn:this.state.selectedExportColumn};
    for (let key in this.state.filters) {
      if (this.state.filters[key]) {
        filters[key] = this.state.filters[key];
      }
    }
    rosterService.exportEmployees(filters, result => {
      ref.destroy();
      if (result.data.Success) {
        message.success("导出用户成功", 4)
        this.setState({
          exportModalStatus: false,
          selectedExportColumn: {}
        }, () => window.open(result.data.Message))
      } else {
        message.error(result.data.Errors[0])
      }
    }, error => message.error("导出用户失败", 4))
  }
  //直接导出基本信息
  exportEmployee2 = () => {
    let ref = Modal.info({
      content: "正在准备需要下载的文件, 下载文件可能被浏览器阻挡, 请注意！"
    });
    const filters = {};
    for (let key in this.state.filters) {
      if (this.state.filters[key]) {
        filters[key] = this.state.filters[key];
      }
    }
    rosterService.exportEmployeesList(filters, res => {
      ref.destroy();
      if (res.data.Success) {
        window.open(res.data.Message);
      } else {
        message.error('导出数据失败, ' + res.data.Errors[0], 4);
      }
    })
  }

  weixinEmployee = () => {
    const ref = Modal.info({ content: "正在同步微信人员, 请稍后..." })
    // rosterService.weixinDepartment(res => {
    //   if (res.data.Success) {
    rosterService.weixinEmployee(res => {
      ref.destroy();
      if (res.data.Success) {
        message.success("微信人员同步成功", 4)
      } else {
        message.error("微信人员同步失败, " + res.data.Errors[0], 4)
      }
    }, error => message.error("微信人员同步失败", 4))
    //   } else {
    //     message.error("微信人员同步失败, " + res.data.Errors[0], 4)
    //   }
    // }, error => message.error("微信人员同步失败", 4))
  }

  detailEmployee = employee_id => {
    sessionStorage.removeItem("hideBackButton")
    sessionStorage.setItem("rosterReadOnly", "yes")

    //过滤信息添加到sessionStorage
    sessionStorage.setItem("employeeListFilter", JSON.stringify(this.state.filters))

    this.props.history.push("/employee/detail/" + employee_id)
  }

  updateEmployee = employee_id => {
    sessionStorage.removeItem("rosterReadOnly")
    sessionStorage.removeItem("hideBackButton")


    //过滤信息添加到sessionStorage
    sessionStorage.setItem("employeeListFilter", JSON.stringify(this.state.filters))
    if (employee_id) {
      this.props.history.push("/employee/detail/" + employee_id)
    } else {
      this.props.history.push("/employee/detail")
    }
  }

  setPageFilter = (pagination, filters, sorter) => {
    sessionStorage.setItem("page", pagination.current);
    var is_order_asc = sorter.order != 'descend';
    console.log(is_order_asc);
    this.setState({
      filters: {
        ...this.state.filters,
        page: pagination.current,
        is_order_asc: is_order_asc,
        order_property: sorter.field,

      }
    }, this.initializePage)
  }

  configEmployee = index => this.setState({
    configPageStatus: "unload",
    configModalStatus: true,
    currentIndex: index,
    jobStatusType: 0
  }, () => rosterService.fetchEmployeeInit({}, meta => {


    this.setState({
      configPageStatus: "loaded",
      meta: meta.data
    });
    //获取离职数据
    rosterService.fetchEmployeeLeaveDetail({ employee_id: this.state.data.Data[index].id }, data => {
      if (data) {
        // this.setState({
        //   emplyee_leave_data: data
        // });
        this.state.leave_date = data.data.leave_date,
          this.state.leave_reason = data.data.reason,
          this.state.leave_type = data.data.leave_type,
          this.tate.stop_insurance_date = data.data.stop_insurance_date
      }
    })
  }))
  toggleConfigModal = () => this.setState({
    configModalStatus: !this.state.configModalStatus
  })

  setJobStatusType = event => {
    this.props.form.resetFields()
    this.setState({ jobStatusType: event.target.value })
  }

  setEmployeeFilter = event => {
    this.setState({
      filters: {
        ...this.state.filters,
        job_number: event.target.value,
        real_name: event.target.value,
        page: 1
      }
    }, () => {
      if (!this.state.filters.real_name) {
        this.initializePage()
      }
    })
  }
  renderTreeNodes = data => data.map(item => {
    if (item.children) {
      return (
        <TreeSelect.TreeNode title={item.name}
          value={item.id}
          key={item.id}
          dataRef={item} >
          {item.children.length !== 0 && this.renderTreeNodes(item.children)}
        </TreeSelect.TreeNode>
      )
    }
    return <TreeSelect.TreeNode {...item} />
  })
  // setDepartmentFilter = (name, values, event) => {
  //   const department_id = event.triggerNode ? event.triggerNode.props.dataRef.id : ""
  //   this.setState({
  //     filters: {
  //       ...this.state.filters,
  //       department_id: department_id,
  //       page: 1
  //     }
  //   }, this.initializePage)
  // }
  setDepartmentFilter = (value) => {
    this.setState({
      filters: {
        ...this.state.filters,
        department_ids: value,
        page: 1
      }
    }, this.initializePage)
  }
  setStatusFilter = event => this.setState({
    filters: {
      ...this.state.filters,
      job_status: event.target.value,
      page: 1
    }
  }, this.initializePage)

  columns = [{
    title: '工号',
    dataIndex: 'job_number',
    key: 'job_number',
    className: "table-global-head-small", sorter: true
  }, {
    title: '姓名',
    dataIndex: 'real_name',
    key: 'real_name',
    className: "table-global-head-small", sorter: true,
    render: (text, record) => <a onClick={this.detailEmployee.bind(this, record.id)}>{text}</a>
  }, {
    title: '英文名',
    dataIndex: 'english_name',
    key: 'english_name',
    className: "table-global-head", sorter: true
  }, {
    title: '部门',
    dataIndex: 'department_name',
    key: 'department_name',
    className: "table-global-head-65x"
  }, {
    title: '职位',
    dataIndex: 'position_name',
    key: 'position_name',
    className: "table-global-head-65x"
  }, {
    title: '入职日期',
    dataIndex: 'entry_date',
    key: 'entry_date',
    className: "table-global-head", sorter: true
  }, {
    title: '在职状态',
    dataIndex: 'employee_type_name',
    key: 'employee_type_name',
    className: "table-global-head-5x", sorter: true,
    render: text => text
  }, {
    title: '操作',
    dataIndex: 'action',
    className: "table-global-head-tiny",
    key: 'action',
    render: (text, record, index) => (
      <Dropdown trigger={["hover", "click", "mouseover"]} overlay={
        <Menu>
          {/* {this.props.access.roster.c_value &&
            <Menu.Item>
              <a onClick={this.detailEmployee.bind(this, record.id)}>
                <Icon type="info-circle-o" style={{ fontSize: "14px" }} />
                <span style={{ margin: "0px 0px 0px 5px" }}>查看</span>
              </a>
            </Menu.Item>} */}
          {this.props.access.roster.u_value &&
            <Menu.Item>
              <a onClick={this.updateEmployee.bind(this, record.id)}>
                <Icon type="edit" style={{ fontSize: "14px" }} />
                <span style={{ margin: "0px 0px 0px 5px" }}>员工详情</span>
              </a>
            </Menu.Item>}
          {this.props.access.roster.u_value &&
            <Menu.Item>
              <a onClick={this.configEmployee.bind(this, index)} >
                <Icon type="setting" style={{ fontSize: "14px" }} />
                <span style={{ margin: "0px 0px 0px 5px" }}>人员调配</span>
              </a>
            </Menu.Item>}
        </Menu>}>
        <a className="ant-dropdown-link">
          操作列表 <Icon type="down" />
        </a>
      </Dropdown>
    )
  }]

  configEmployeeAction = () => {
    if (0 === this.state.jobStatusType) {
      this.toggleConfigModal();
      return
    }
    this.props.form.validateFields((err, values) => {
      if (!err) {
        let post = {
          employee_id: this.state.data.Data[this.state.currentIndex].id,
          ...values
        };
        let action;
        switch (this.state.jobStatusType) {
          case 1:
            post = {
              ...post,
              valid_date: values.valid_date.format("YYYY-MM-DD")
            }
            action = rosterService.arrangePosition;
            break;
          case 2:
            post = {
              ...post,
              leave_date: values.leave_date.format("YYYY-MM-DD"),
              stop_insurance_date: values.stop_insurance_date.format("YYYY-MM-DD")
            }
            action = rosterService.fireEmployee
            break;
          case 3:
            post = {
              ...post,
              work_type: 1,
              contract_start_date: values.contract_start_date.format("YYYY-MM-DD"),
              contract_end_date: values.contract_end_date.format("YYYY-MM-DD")
            }
            action = rosterService.changeJobStatus
            break;
          case 4:
            post = {
              ...post,
              work_type: 2,
              contract_start_date: values.contract_start_date.format("YYYY-MM-DD"),
              contract_end_date: values.contract_end_date.format("YYYY-MM-DD")
            }
            action = rosterService.changeJobStatus
            break;
          case 5:
            post = {
              ...post,
              valid_date: values.valid_date.format("YYYY-MM-DD")
            }
            action = rosterService.employeeEnrol
            break;
          case 6:
            post = {
              ...post,
              entry_date: values.entry_date.format("YYYY-MM-DD")
            }
            action = rosterService.employeeEntry
            break;
          default:
            return;
        }
        // console.log(post, action)
        action(post, result => {
          if (result.data.Success) {
            message.success("人员调整成功", 4)
            this.toggleConfigModal();
            this.initializePage();
          } else {
            message.error("人员调整失败, " + result.data.Errors[0], 4)
          }
        }, error => message.error("人员调整失败", 4))
      }
    })
  }
  renderTreeNodesEx = data => data.map(item => {
    if (item.children) {
      return (
        <TreeSelect.TreeNode title={item.name}
          value={item.id}
          key={item.id}
          dataRef={item} >
          {item.children.length !== 0 && this.renderTreeNodesEx(item.children)}
        </TreeSelect.TreeNode>
      )
    }
    return <TreeSelect.TreeNode {...item} />
  })

  setChangeDepartment = (id, value, event) => {
    const triggeredPositions = event.triggerNode ? event.triggerNode.props.dataRef.positions : []
    this.setState({
      triggeredPositions: triggeredPositions,
    }, () => {
      this.props.form.setFieldsValue({ "new_position_id": "" })
    })
  }
  //切换校区加载对应部门
  setCampusFilter = value => {
    this.setState(
      {
        filters: {
          ...this.state.filters,
          campus: value,
          department_ids: null,
          page: 1
        }
      }, () => {
        //加载当前校区下的部门
        DepartmentStructure.getDepartmentsList({ campus: value }, result => {
          if (this.pageExist) {
            this.setState({ department: result.data })
          }
        })
        //查询
        this.initializePage();
      }
    );

  }
  //切换性别
  setGenderFilter = value => {
    this.setState(
      {
        filters: {
          ...this.state.filters,
          gender: value,
        }
      }
    );
  }
  //切换学历
  setQualificationsFilter = value => {
    this.setState(
      {
        filters: {
          ...this.state.filters,
          qualification_id: value,
        }
      }
    );
  }
  //输入年龄
  setAgeFilter = event => {
    this.setState(
      {
        filters: {
          ...this.state.filters,
          age: event.target.value,
        }
      }
    );
  }
handleChange=(value)=>{
  this.setState({
    filters:{
      ...this.state.filters,
      export_ids:value  
    }
  })
}
handleJobStatusChange=(value)=>{
  this.setState({
    filters:{
      ...this.state.filters,
      multi_job_status:value  
    }
  })
}
  render() {
    return (
      <div className="app-module-item">
        <div style={{ float: "left" }}>
          {this.props.access.roster.c_value &&
            <Button style={{ margin: "0px 5px 10px 0px" }}
              type="primary" icon="plus-circle-o"
              onClick={this.updateEmployee.bind(this, null)}>
              新增
            </Button>}
          {this.props.access.roster.d_value &&
            <Button style={{ margin: "0px 5px 10px 0px" }}
              type="primary" icon="minus-circle-o"
              onClick={this.deleteEmployee}>
              删除
            </Button>}
          {this.props.access.roster.import_value &&
            <span>
              <Button style={{ margin: "0px 5px 10px 0px", display: "none" }}
                type="primary" icon="cloud-upload-o"
                onClick={this.toggleImportModal}>
                导入
              </Button>
              <Modal width="600px" title="花名册导入"
                visible={this.state.importModalStatus}
                destroyOnClose={true}
                onCancel={this.toggleImportModal}
                footer={<Button type="back" onClick={this.toggleImportModal}>关闭</Button>}>
                <div style={{ textAlign: "center", margin: "20px 0px 20px" }}>
                  <div>
                    <Button type="primary" onClick={this.downloadTemplate}>
                      <Icon type="cloud-download-o" />
                      <span>下载模板</span>
                    </Button>
                  </div>
                  <div style={{ marginTop: "40px" }}>
                    <div>导入文件</div>
                    <Input type="file" style={{ height: "38px" }} onChange={this.setUploadedFile} />
                    <Button type="primary" style={{ marginTop: "20px" }} onClick={this.importEmployee}>
                      <Icon type="cloud-upload-o" />
                      <span>开始导入</span>
                    </Button>
                  </div>
                </div>
              </Modal>
            </span>}
          {this.props.access.roster.u_value &&
            <Button style={{ margin: "0px 5px 10px 0px" }}
              type="primary" icon="sync"
              onClick={this.weixinEmployee}>
              微信人员同步
            </Button>}
          {this.props.access.roster.export_value &&
            <span>
              <Select
                mode="multiple"
                style={{ width: "400px",margin: "0px 5px 10px 0px" }}
                onChange={this.handleChange}
                filterOption={false}  placeholder="请选择导出模块(不选默认导出基本信息)">
                <Select.Option key={'1'} value={'1'}>
                  基本信息
                </Select.Option>
                <Select.Option key={'2'} value={'2'}>
                  子女信息
                </Select.Option>
                <Select.Option key={'3'} value={'3'}>
                  合同信息
                </Select.Option>
                <Select.Option key={'4'} value={'4'}>
                  教育信息
                </Select.Option>
                <Select.Option key={'5'} value={'5'}>
                  工作经历
                </Select.Option>
                <Select.Option key={'6'} value={'6'}>
                  个人足迹
                </Select.Option>
                <Select.Option key={'7'} value={'7'}>
                  员工证照
                </Select.Option>
                <Select.Option key={'8'} value={'8'}>
                  培训基金
                </Select.Option>
                <Select.Option key={'9'} value={'9'}>
                  参保详情
                </Select.Option>
              </Select>
              <Button style={{ margin: "0px 5px 10px 0px" }}
                type="primary" icon="cloud-download-o"
                onClick={this.exportEmployee2}>
                导出
              </Button>
              <Button style={{ margin: "0px 5px 10px 0px" }}
                type="primary" icon="cloud-download-o"
                onClick={this.exportEmployee}>
                选择性导出
              </Button>
              <Modal width="600px" title="花名册导出"
                visible={this.state.exportModalStatus}
                onOk={this.exportEmployeeAction}
                onCancel={this.toggleExportModal}
                destroyOnClose={true}>
                <h3>
                  <span>请选择需要导出的列</span>
                  {/* <small style={{ color: '#f81d22' }}> * 不选择，则默认导出所有列</small> */}
                </h3>
                {"unload" === this.state.exportPageStatus &&
                  <div style={{ textAlign: 'center', margin: '100px 0px' }}>
                    <Spin size="large" />
                  </div>}
                {"loaded" === this.state.exportPageStatus &&
                  <Row>
                    {Object.keys(this.state.exportColumn).map(key =>
                      <Col span={6} style={{ padding: 2 }} key={key}>
                        <Checkbox value={key} onChange={this.setExportColumn}>
                          {this.state.exportColumn[key]}
                        </Checkbox>
                      </Col>
                    )}
                  </Row>}
              </Modal>
            </span>}
        </div>
        {this.props.access.roster.u_value && this.state.configModalStatus &&
          <Modal width="1000px" title="人员调配"
            visible={this.state.configModalStatus}
            onOk={this.configEmployeeAction}
            onCancel={this.toggleConfigModal}
            destroyOnClose={true}>
            <div style={{ height: "491px" }}>
              <Row>
                <Col span={12} style={{ textAlign: "center", height: "30px", lineHeight: "30px" }}>
                  <span style={{ display: "inline-block", width: "40%", textAlign: "right" }}>
                    中文名:&nbsp;&nbsp;
                    </span>
                  <span style={{ display: "inline-block", width: "60%", textAlign: "left" }}>
                    {this.state.data.Data[this.state.currentIndex].real_name}
                  </span>
                </Col>
                <Col span={12} style={{ textAlign: "center", height: "30px", lineHeight: "30px" }}>
                  <span style={{ display: "inline-block", width: "40%", textAlign: "right" }}>
                    英文名:&nbsp;&nbsp;
                    </span>
                  <span style={{ display: "inline-block", width: "60%", textAlign: "left" }}>
                    {this.state.data.Data[this.state.currentIndex].english_name}
                  </span>
                </Col>
                <Col span={12} style={{ textAlign: "center", height: "30px", lineHeight: "30px" }}>
                  <span style={{ display: "inline-block", width: "40%", textAlign: "right" }}>
                    工号:&nbsp;&nbsp;
                    </span>
                  <span style={{ display: "inline-block", width: "60%", textAlign: "left" }}>
                    {this.state.data.Data[this.state.currentIndex].job_number}
                  </span>
                </Col>
                <Col span={12} style={{ textAlign: "center", height: "30px", lineHeight: "30px" }}>
                  <span style={{ display: "inline-block", width: "40%", textAlign: "right" }}>
                    部门:&nbsp;&nbsp;
                    </span>
                  <span style={{ display: "inline-block", width: "60%", textAlign: "left" }}>
                    {this.state.data.Data[this.state.currentIndex].department_name}
                  </span>
                </Col>
              </Row>
              {"unload" === this.state.configPageStatus &&
                <div style={{ textAlign: 'center', margin: '100px 0px' }}>
                  <Spin size="large" />
                </div>}
              {"loaded" === this.state.configPageStatus &&
                <Form layout="inline">
                  <div style={{ padding: "10px 0px" }}>
                    <span style={{ display: "inline-block", width: "120px", textAlign: "right" }}>变动类型:&nbsp;&nbsp;</span>
                    <Radio.Group
                      value={this.state.jobStatusType}
                      onChange={this.setJobStatusType}>
                      <Radio.Button value={1}>岗位调整</Radio.Button>
                      <Radio.Button value={2}
                        disabled={false && 5 === this.state.data.Data[this.state.currentIndex].job_status}>
                        离职
                      </Radio.Button>
                      <Radio.Button value={3}
                        disabled={false && 3 !== this.state.data.Data[this.state.currentIndex].job_status}>
                        兼职转全职
                      </Radio.Button>
                      <Radio.Button value={4}
                        disabled={false && 4 !== this.state.data.Data[this.state.currentIndex].job_status}>
                        全职转兼职
                      </Radio.Button>
                      <Radio.Button value={5}
                        disabled={false && 2 !== this.state.data.Data[this.state.currentIndex].job_status}>
                        试用期转正
                      </Radio.Button>
                      <Radio.Button value={6}
                        disabled={5 !== this.state.data.Data[this.state.currentIndex].job_status}>
                        离职转在职
                      </Radio.Button>
                    </Radio.Group>
                  </div>
                  {0 === this.state.jobStatusType &&
                    <p style={{ padding: "15px 0px", textAlign: "center", color: "red" }}>请选择变动类型</p>
                  }
                  {1 === this.state.jobStatusType &&
                    <div>
                      <div style={{ padding: "10px 0px 0px" }}>
                        <h4>信息变动</h4>
                        <Divider style={{ margin: "7px 0px 10px" }} />
                      </div>
                      <div style={{ display: "flex" }}>
                        <div style={{ flex: 1 }}>
                          <div style={{ textAlign: "center" }}>变动前</div>
                          <div style={{ padding: "10px 0px" }}>
                            <span style={{ display: "inline-block", width: "120px", textAlign: "right" }}>部门:&nbsp;&nbsp;</span>
                            <Input style={{ width: "210px" }} disabled
                              value={this.state.data.Data[this.state.currentIndex].department_name} />
                          </div>
                          <div style={{ padding: "10px 0px" }}>
                            <span style={{ display: "inline-block", width: "120px", textAlign: "right" }}>职位:&nbsp;&nbsp;</span>
                            <Input style={{ width: "210px" }} disabled
                              value={this.state.data.Data[this.state.currentIndex].position_name} />
                          </div>
                        </div>
                        <Divider type="vertical" />
                        <div style={{ flex: 1 }}>
                          <div style={{ textAlign: "center" }}>变动后</div>
                          <div style={{ padding: "10px 0px" }} className="roster-config-content">
                            <Form.Item label="部门">
                              {this.props.form.getFieldDecorator("new_department_id", {
                                rules: [{ required: true, message: '请输入部门' }],
                                initialValue: this.state.config.new_department_id
                              })(
                                <TreeSelect style={{ width: "210px" }}
                                  allowClear
                                  placeholder="请选择部门"
                                  showSearch={false}
                                  autoExpandParent={true}
                                  dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                  treeDefaultExpandAll
                                  onChange={this.setChangeDepartment}>
                                  {this.renderTreeNodesEx(this.state.meta.departments)}
                                </TreeSelect>
                              )}
                            </Form.Item>
                          </div>
                          <div style={{ padding: "10px 0px" }} className="roster-config-content">
                            <Form.Item label="职位">
                              {this.props.form.getFieldDecorator("new_position_id", {
                                rules: [{ required: true, message: '请选择职位' }],
                                initialValue: this.state.config.new_position_id
                              })(
                                <Select style={{ width: "210px" }} allowClear>
                                  {this.state.triggeredPositions.map(position => (
                                    <Select.Option key={position.id} value={position.id} dataRef={position}>
                                      {position.name}
                                    </Select.Option>
                                  ))}
                                </Select>
                              )}
                            </Form.Item>
                          </div>
                        </div>
                      </div>
                      <div style={{ padding: "10px 0px" }} className="roster-config-content">

                        <Form.Item label="生效时间">
                          {this.props.form.getFieldDecorator("valid_date", {
                            rules: [{ required: true, message: '请选择生效时间' }],
                            initialValue: this.state.config.valid_date ? moment(this.state.config.valid_date) : null
                          })(<DatePicker style={{ width: "210px" }} />)}
                        </Form.Item>
                      </div>
                      <div style={{ padding: "10px 0px" }} className="roster-config-content">
                        <Form.Item label="原因">
                          {this.props.form.getFieldDecorator("reason", {
                            rules: [{ required: true, message: '请填写原因' }],
                            initialValue: this.state.config.reason
                          })(<Input.TextArea style={{ width: "594px" }} rows={4}></Input.TextArea>)}
                        </Form.Item>
                      </div>
                    </div>}
                  {2 === this.state.jobStatusType &&
                    <div>
                      <div style={{ padding: "10px 0px 0px" }}>
                        <h4>信息变动</h4>
                        <Divider style={{ margin: "7px 0px 10px" }} />
                      </div>
                      <div style={{ padding: "10px 0px" }} className="roster-config-content">
                        <Form.Item label="离职时间">
                          {this.props.form.getFieldDecorator("leave_date", {
                            rules: [{ required: true, message: '请选择离职时间' }],
                            initialValue: this.state.leave_date ? moment(this.state.leave_date) : null
                          })(<DatePicker style={{ width: "210px" }} />)}
                        </Form.Item>
                      </div>
                      <div style={{ padding: "10px 0px" }} className="roster-config-content">
                        <Form.Item label="离职类别">
                          {this.props.form.getFieldDecorator("leave_type", {
                            rules: [{ required: true, message: '请选择离职类别' }],
                            initialValue: this.state.leave_type
                          })(
                            <Radio.Group>
                              <Radio.Button value={1}>合同期内辞职</Radio.Button>
                              <Radio.Button value={2}>合同期满离职</Radio.Button>
                              <Radio.Button value={3}>试用期不合格</Radio.Button>
                              <Radio.Button value={4}>自然裁员</Radio.Button>
                              <Radio.Button value={5}>违纪</Radio.Button>
                            </Radio.Group>
                          )}
                        </Form.Item>
                      </div>
                      <div style={{ padding: "10px 0px" }} className="roster-config-content">
                        <Form.Item label="停保月份">
                          {this.props.form.getFieldDecorator("stop_insurance_date", {
                            rules: [{ required: true, message: '请选择停保月份' }],
                            initialValue: this.state.stop_insurance_date ? moment(this.state.stop_insurance_date) : null
                          })(<DatePicker.MonthPicker style={{ width: "210px" }} />)}
                        </Form.Item>
                      </div>
                      <div style={{ padding: "10px 0px" }} className="roster-config-content">
                        <Form.Item label="离职原因">
                          {this.props.form.getFieldDecorator("reason", {
                            rules: [{ required: true, message: '请填写离职原因' }],
                            initialValue: this.state.leave_reason
                          })(<Input.TextArea style={{ width: "594px" }} rows={4}></Input.TextArea>)}
                        </Form.Item>
                      </div>
                    </div>}
                  {3 === this.state.jobStatusType &&
                    <div>
                      <div style={{ padding: "10px 0px 0px" }}>
                        <h4>信息变动</h4>
                        <Divider style={{ margin: "7px 0px 10px" }} />
                      </div>
                      <div style={{ display: "flex" }}>
                        <div style={{ flex: 1 }}>
                          <div style={{ textAlign: "center" }}>变动前</div>
                          <div style={{ padding: "10px 0px" }}>
                            <span style={{ display: "inline-block", width: "120px", textAlign: "right" }}>部门:&nbsp;&nbsp;</span>
                            <Input style={{ width: "210px" }} disabled
                              value={this.state.data.Data[this.state.currentIndex].department_name} />
                          </div>
                          <div style={{ padding: "10px 0px" }}>
                            <span style={{ display: "inline-block", width: "120px", textAlign: "right" }}>职位:&nbsp;&nbsp;</span>
                            <Input style={{ width: "210px" }} disabled
                              value={this.state.data.Data[this.state.currentIndex].position_name} />
                          </div>
                          <div style={{ padding: "10px 0px" }} >
                            <span style={{ display: "inline-block", width: "120px", textAlign: "right" }}>员工类型:&nbsp;&nbsp;</span>
                            <Input style={{ width: "210px" }} disabled
                              value="兼职" />
                          </div>
                        </div>
                        <Divider type="vertical" />
                        <div style={{ flex: 1 }}>
                          <div style={{ textAlign: "center" }}>变动后</div>
                          <div style={{ padding: "10px 0px" }} className="roster-config-content">
                            <Form.Item label="部门">
                              {this.props.form.getFieldDecorator("new_department_id", {
                                rules: [{ required: true, message: '请输入部门' }],
                                initialValue: this.state.config.new_department_id
                              })(
                                <TreeSelect style={{ width: "210px" }}
                                  allowClear
                                  placeholder="请选择部门"
                                  showSearch={false}
                                  autoExpandParent={true}
                                  dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                  treeDefaultExpandAll
                                  onChange={this.setChangeDepartment}>
                                  {this.renderTreeNodesEx(this.state.meta.departments)}
                                </TreeSelect>
                              )}
                            </Form.Item>
                          </div>
                          <div style={{ padding: "10px 0px" }} className="roster-config-content">
                            <Form.Item label="职位">
                              {this.props.form.getFieldDecorator("new_position_id", {
                                rules: [{ required: true, message: '请选择职位' }],
                                initialValue: this.state.config.new_position_id
                              })(
                                <Select style={{ width: "210px" }} allowClear>
                                  {this.state.triggeredPositions.map(position => (
                                    <Select.Option key={position.id} value={position.id} dataRef={position}>
                                      {position.name}
                                    </Select.Option>
                                  ))}
                                </Select>
                              )}
                            </Form.Item>
                          </div>
                          <div style={{ padding: "10px 0px" }} className="roster-config-content">
                            <Form.Item label="员工类型">
                              <Input style={{ width: "210px" }} disabled
                                value="全职" />
                            </Form.Item>
                          </div>
                          {/* <div style={{ padding: "10px 0px",textAlign:"right",paddingRight:"35px" }}  >
                              <span style={{ display: "inline-block", width: "120px" }}>员工类型:&nbsp;&nbsp;</span>
                              <Input style={{ width: "210px" }} disabled
                                value="全职" />
                            </div> */}
                        </div>
                      </div>
                      <div style={{ padding: "10px 0px 0px" }}>
                        <h4>合同签订</h4>
                        <Divider style={{ margin: "7px 0px 10px" }} />
                      </div>
                      <div style={{ padding: "10px 0px" }}>
                        <span style={{ display: "inline-block", width: "120px", textAlign: "right" }}>合同类型:&nbsp;&nbsp;</span>
                        <Input style={{ width: "210px" }} disabled value="劳动合同" />
                      </div>
                      <div style={{ display: "flex" }}>
                        <div style={{ flex: 1, padding: "10px 0px", width: "120px", textAlign: "left" }} className="roster-config-content">
                          <Form.Item label="合同开始时间">
                            {this.props.form.getFieldDecorator("contract_start_date", {
                              rules: [{ required: true, message: '请选择合同开始时间' }],
                              initialValue: this.state.config.contract_start_date ? moment(this.state.config.contract_start_date) : null
                            })(<DatePicker style={{ width: "210px" }} />)}
                          </Form.Item>
                        </div>
                        <div style={{ flex: 1, padding: "10px 0px" }} className="roster-config-content">
                          <Form.Item label="合同结束时间">
                            {this.props.form.getFieldDecorator("contract_end_date", {
                              rules: [{ required: true, message: '请选择合同结束时间' }],
                              initialValue: this.state.config.contract_end_date ? moment(this.state.config.contract_end_date) : null
                            })(<DatePicker style={{ width: "210px" }} />)}
                          </Form.Item>
                        </div>
                      </div>
                    </div>}
                  {4 === this.state.jobStatusType &&
                    <div>
                      <div>
                        <h4 style={{ padding: "10px 0px 0px" }}>信息变动</h4>
                        <Divider style={{ margin: "7px 0px 10px" }} />
                      </div>
                      <div style={{ display: "flex" }}>
                        <div style={{ flex: 1 }}>
                          <div style={{ textAlign: "center" }}>变动前</div>
                          <div style={{ padding: "10px 0px" }}>
                            <span style={{ display: "inline-block", width: "120px", textAlign: "right" }}>部门:&nbsp;&nbsp;</span>
                            <Input style={{ width: "210px" }} disabled
                              value={this.state.data.Data[this.state.currentIndex].department_name} />
                          </div>
                          <div style={{ padding: "10px 0px" }}>
                            <span style={{ display: "inline-block", width: "120px", textAlign: "right" }}>职位:&nbsp;&nbsp;</span>
                            <Input style={{ width: "210px" }} disabled
                              value={this.state.data.Data[this.state.currentIndex].position_name} />
                          </div>
                          <div style={{ padding: "10px 0px" }}>
                            <span style={{ display: "inline-block", width: "120px", textAlign: "right" }}>员工类型:&nbsp;&nbsp;</span>
                            <Input style={{ width: "210px" }} disabled
                              value="全职" />
                          </div>
                        </div>
                        <Divider type="vertical" />
                        <div style={{ flex: 1 }}>
                          <div style={{ textAlign: "center" }}>变动后</div>
                          <div style={{ padding: "10px 0px" }} className="roster-config-content">
                            <Form.Item label="部门">
                              {this.props.form.getFieldDecorator("new_department_id", {
                                rules: [{ required: true, message: '请输入部门' }],
                                initialValue: this.state.config.new_department_id
                              })(
                                <TreeSelect style={{ width: "210px" }}
                                  allowClear
                                  placeholder="请选择部门"
                                  showSearch={false}
                                  autoExpandParent={true}
                                  dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                  treeDefaultExpandAll
                                  onChange={this.setChangeDepartment}>
                                  {this.renderTreeNodesEx(this.state.meta.departments)}
                                </TreeSelect>
                              )}
                            </Form.Item>
                          </div>
                          <div style={{ padding: "10px 0px" }} className="roster-config-content">
                            <Form.Item label="职位">
                              {this.props.form.getFieldDecorator("new_position_id", {
                                rules: [{ required: true, message: '请选择职位' }],
                                initialValue: this.state.config.new_position_id
                              })(
                                <Select style={{ width: "210px" }} allowClear>
                                  {this.state.triggeredPositions.map(position => (
                                    <Select.Option key={position.id} value={position.id} dataRef={position}>
                                      {position.name}
                                    </Select.Option>
                                  ))}
                                </Select>
                              )}
                            </Form.Item>
                          </div>
                          <div style={{ padding: "10px 0px" }} className="roster-config-content">
                            <Form.Item label="员工类型">
                              <Input style={{ width: "210px" }} disabled
                                value="兼职" />
                            </Form.Item>
                          </div>

                          {/* <div style={{ padding: "10px 0px",textAlign:"right",paddingRight:"35px" }}>
                              <span style={{  width: "120px"}}>员工类型:&nbsp;&nbsp;</span>
                              
                                
                            </div> */}
                        </div>
                      </div>
                      <div style={{ padding: "10px 0px 0px" }}>
                        <h4>合同签订</h4>
                        <Divider style={{ margin: "7px 0px 10px" }} />
                      </div>
                      <div style={{ padding: "10px 0px" }}>
                        <span style={{ display: "inline-block", width: "120px", textAlign: "right" }}>合同类型:&nbsp;&nbsp;</span>
                        <Input style={{ width: "210px" }} disabled value="兼职协议" />
                      </div>
                      <div style={{ display: "flex" }}>
                        <div style={{ flex: 1, padding: "10px 0px", width: "120px", textAlign: "left" }} className="roster-config-content">
                          <Form.Item label="合同开始时间">
                            {this.props.form.getFieldDecorator("contract_start_date", {
                              rules: [{ required: true, message: '请选择合同开始时间' }],
                              initialValue: this.state.config.contract_start_date ? moment(this.state.config.contract_start_date) : null
                            })(<DatePicker style={{ width: "210px" }} />)}
                          </Form.Item>
                        </div>
                        <div style={{ flex: 1, padding: "10px 0px" }} className="roster-config-content">
                          <Form.Item label="合同结束时间">
                            {this.props.form.getFieldDecorator("contract_end_date", {
                              rules: [{ required: true, message: '请选择合同结束时间' }],
                              initialValue: this.state.config.contract_end_date ? moment(this.state.config.contract_end_date) : null
                            })(<DatePicker style={{ width: "210px" }} />)}
                          </Form.Item>
                        </div>
                      </div>
                    </div>}
                  {5 === this.state.jobStatusType &&
                    <div>
                      <div style={{ padding: "10px 0px 0px" }}>
                        <h4>信息变动</h4>
                        <Divider style={{ margin: "7px 0px 10px" }} />
                      </div>
                      <div style={{ padding: "10px 0px" }} className="roster-config-content">
                        <Form.Item label="生效时间">
                          {this.props.form.getFieldDecorator("valid_date", {
                            rules: [{ required: true, message: '请选择生效时间' }],
                            initialValue: this.state.config.valid_date ? moment(this.state.config.valid_date) : null
                          })(<DatePicker style={{ width: "210px" }} />)}
                        </Form.Item>
                      </div>
                      <div style={{ padding: "10px 0px" }} className="roster-config-content">
                        <Form.Item label="备注">
                          {this.props.form.getFieldDecorator("remark", {
                            rules: [{ required: true, message: '请填写备注' }],
                            initialValue: this.state.config.remark
                          })(<Input.TextArea style={{ width: "594px" }} rows={4}></Input.TextArea>)}
                        </Form.Item>
                      </div>
                    </div>}
                  {6 === this.state.jobStatusType &&
                    <div>
                      <div style={{ padding: "10px 0px 0px" }}>
                        <h4>信息变动</h4>
                        <Divider style={{ margin: "7px 0px 10px" }} />
                      </div>
                      <div style={{ padding: "10px 0px" }} className="roster-config-content">
                        <Form.Item label="入职时间">
                          {this.props.form.getFieldDecorator("entry_date", {
                            rules: [{ required: true, message: '请选择入职时间' }],
                            initialValue: this.state.config.entry_date ? moment(this.state.config.entry_date) : null
                          })(<DatePicker style={{ width: "210px" }} />)}
                        </Form.Item>
                      </div>
                    </div>}
                </Form>}
            </div>
          </Modal>
        }
        <div style={{ clear: "both" }}></div>
        <div style={{ float: "left" }}>
          <span style={{ marginRight: "5px" }}>校区 : </span>
          <Select style={{ width: "200px", margin: '0px 5px 10px 0px' }} allowClear onChange={this.setCampusFilter}>
            <Select.Option key={0} value={0}></Select.Option>
            <Select.Option key={1} value={1}>{'华山校HS'}</Select.Option>
            <Select.Option key={2} value={2}>{'中星城校ZXC'}</Select.Option>
            <Select.Option key={3} value={3}>{'时光里校SGL'}</Select.Option>
            <Select.Option key={4} value={4}>{'晶耀前滩校JYC'}</Select.Option>
          </Select>
          <TreeSelect style={{ minWidth: "300px", margin: '0px 5px 10px 0px' }}
            treeCheckable={true}
            showSearch={false}
            allowClear
            placeholder="请选择部门"
            autoExpandParent={true}
            dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
            treeDefaultExpandAll
            value={this.state.filters.department_ids}
            onChange={this.setDepartmentFilter}
            showCheckedStrategy='SHOW_ALL'
          >

            {this.renderTreeNodes(this.state.department)}
          </TreeSelect>
          <span style={{ marginRight: "5px" }}>性别 : </span>
          <Select style={{ width: "200px", margin: '0px 5px 10px 0px' }} allowClear onChange={this.setGenderFilter} value={this.state.filters.gender}>
            <Select.Option key={1} value="男">{'男'}</Select.Option>
            <Select.Option key={2} value="女">{'女'}</Select.Option>
          </Select>
          <Input style={{ width: 200, margin: "0px 5px 10px 0px" }}
            placeholder="年龄"
            value={this.state.filters.age}
            onChange={this.setAgeFilter} />


        </div>
        <div style={{ clear: "both" }}></div>
        <div style={{ float: "left" }}>
          <span style={{ marginRight: "5px" }}>学历 : </span>
          <Select style={{ width: "200px", margin: '0px 5px 10px 0px' }} allowClear onChange={this.setQualificationsFilter} value={this.state.filters.qualification_id}>
            <Select.Option key={4} value={4}>专科</Select.Option>
            <Select.Option key={3} value={3}>本科</Select.Option>
            <Select.Option key={2} value={2}>硕士/MBA/EMBA</Select.Option>
            <Select.Option key={1} value={1}>博士</Select.Option>
          </Select>
          <Select
                mode="multiple"
                style={{ width: "200px",margin: "0px 5px 10px 0px" }}
                onChange={this.handleJobStatusChange}
                filterOption={false}  placeholder="请选择员工状态">
                <Select.Option key={'4'} value={'4'}>
                全职
                </Select.Option>
                <Select.Option key={'3'} value={'3'}>
                兼职
                </Select.Option>
                <Select.Option key={'5'} value={'5'}>
                离职
                </Select.Option>
                <Select.Option key={'2'} value={'2'}>
                试用
                </Select.Option>
              </Select>
          {/* <Radio.Group style={{ margin: '0px 5px 10px 0px' }}
            value={this.state.filters.job_status}
            onChange={this.setStatusFilter}>
            <Radio.Button value={0}>全部</Radio.Button>
            <Radio.Button value={4}>全职</Radio.Button>
            <Radio.Button value={3}>兼职</Radio.Button>
            <Radio.Button value={5}>离职</Radio.Button>
            <Radio.Button value={2}>试用</Radio.Button>
          </Radio.Group> */}
          <Input.Search style={{ width: 200, margin: "0px 5px 10px 0px" }}
            placeholder="员工 工号/姓名"
            onSearch={this.initializePage}
            value={this.state.filters.real_name}
            onChange={this.setEmployeeFilter}
            enterButton />

        </div>
        <div style={{ clear: "both" }}></div>
        <Divider style={{ margin: "7px 0px 10px" }} />
        <div>
          {("unload" === this.state.pageStatus || "reload" === this.state.pageStatus) &&
            <div style={{ textAlign: 'center', margin: '100px 0px' }}>
              <Spin size="large" />
            </div>}
          {"loaded" === this.state.pageStatus &&
            <Table columns={this.columns}
              dataSource={this.state.data.Data}
              rowSelection={this.rowSelection}
              rowKey={record => record.id}
              pagination={{
                total: this.state.data.Total,
                pageSize: this.state.data.PageSize,
                current: this.state.filters.page
              }}
              onChange={this.setPageFilter} />}
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/routes/EmployeeManagement/Employee.js